module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/battle-payments.09553b15.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/battle-payments.png
// module id = 3736
// module chunks = 11